export { default } from './ConfigHelperHOC';
